import { useEffect, useRef, useState } from 'react'
import Image from '../Image/Image'

import useWindowSize from '../../hooks/useWindowSize'

import { getCssVar } from '../../utils/css'

export default function EventCard (props = {
    datetime_end: null,
    datetime_start: null,
    id: null,
    slug: null,
    text: null,
    title: null,
    thumbnail: null,
    url: null
}) {
    const {
        datetime_end: datetimeEnd,
        datetime_start: datetimeStart,
        id,
        slug,
        text,
        title,
        thumbnail,
        url
    } = props

    if (!((id || slug)
            || title))
        return null

    const days = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]

    const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ]

    const start = new Date(
        datetimeStart)

    const startDate = start
        .getDate()

    const startDay
        = days[start.getDay()]

    const startMonth
        = months[start.getMonth()]

    const startTime = `${
        start.getHours() > 12
            ? start.getHours() - 12
            : start.getHours()}:${
        String(start.getMinutes())
            .padStart(2, '0')} ${
        start.getHours() > 11
            ? 'P'
            : 'A'}M`

    const tz = start
        .toLocaleDateString('en-us', {
            timeZoneName: 'short'
        })
        .split(' ')[1] || null

    const end = datetimeEnd
        && new Date(datetimeEnd)

    const isDuration = end
        && end.getDate()
            === startDate
        && end.getDay()
            === start.getDay()
        && end.getMonth()
            === start.getMonth()
        && end.getFullYear()
            === start.getFullYear()

    const endTime = isDuration
        && `${
            end.getHours() > 12
                ? end
                    .getHours() - 12
                : end
                    .getHours()}:${
            String(end
                .getMinutes())
                .padStart(2, '0')} ${
            end.getHours() > 11
                ? 'P'
                : 'A'}M`

    const durationMS = isDuration
        && end.getTime()
            - start.getTime()

    const duration = durationMS > 0
        ? `PT${end.getHours()
                - start.getHours()
            ? `${end.getHours()
                - start.getHours()}H`
            : ''}${Math.floor((
            durationMS
                / (1000 * 60))
                    % 60)}M`
            .replace(/H0M$/, 'H')
        : null

    const size = useWindowSize()

    const thumbnailWrapper = useRef()

    const [thumbnailHeight, setThumbnailHeight] = useState(0)

    useEffect(() => {
        if (!thumbnailWrapper.current
                || thumbnailHeight === thumbnailWrapper.current.clientHeight)
            return

        setThumbnailHeight(thumbnailWrapper.current.clientHeight)
    }, [size, thumbnailWrapper.current])

    const thumbnailSrc = thumbnail
            && (thumbnail || '').match(/\//)
        ? `${thumbnail}?w=726`
        : '/images/dashboard-content-thumbnail-fallback.svg'

    return (
        <div className="event-card dashboard-home-events-item display-flex flex-direction-column flex-grow">
            <a
                className="event-card-thumb display-block margin-b"
                aria-hidden="true"
                href={url}
                rel="noopener noreferrer"
                target="_blank"
                title="Opens in a new tab"
                tabIndex="-1"
            >
                <span className="event-card-when body-3">
                    <span className="event-card-when-month">{startMonth}</span>
                    <span className="event-card-when-date">{startDate}</span>
                </span>
                <div
                    className="event-card-thumb-wrapper"
                    role="presentation"
                    ref={thumbnailWrapper}
                >
                    <Image
                        src={thumbnailSrc}
                        className="position-absolute article-card-thumb"
                        alt=""
                        data-object-fit="cover"
                        loading="lazy"
                    />
                </div>
            </a>

            <div className="margin-1-b">
                <a
                    className="body-4 display display-inline-block"
                    href={url}
                    rel="noopener noreferrer"
                    target="_blank"
                    title="Opens in a new tab"
                    style={{
                        color: getCssVar('--navy')
                    }}
                >
                    <span className="font-weight-medium">
                        {title}
                    </span>
                </a>
            </div>

            <p
                className="body-6"
                style={{
                    color: getCssVar('--navy')
                }}
            >
                {!isDuration
                    && (
                        <time
                            dateTime={start}
                            className="display-block font-weight-medium"
                        >
                            <span className="text-screen-reader">
                                <br />
                                {startDay}, {startMonth} {startDate},
                            </span>
                            {startTime} {tz}
                        </time>)}
                {endTime
                    && (
                        <>
                            <time
                                dateTime={start}
                                className="text-screen-reader"
                            >
                                <br />
                                {startDay}, {startMonth} {startDate},
                            </time>
                            <time
                                dateTime={duration}
                                className="display-block font-weight-medium"
                            >
                                {startTime} &ndash; {endTime} {tz}
                            </time>
                        </>)}
            </p>
            {text
                && (
                    <p
                        className="body-6 margin-1-b margin-1-t"
                    >
                        {text}
                    </p>
                )}
        </div>
    )
}
